import { render, staticRenderFns } from "./Health.vue?vue&type=template&id=4abf6262&scoped=true&"
import script from "./Health.vue?vue&type=script&lang=ts&"
export * from "./Health.vue?vue&type=script&lang=ts&"
import style0 from "./Health.vue?vue&type=style&index=0&id=4abf6262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abf6262",
  null
  
)

component.options.__file = "Health.vue"
export default component.exports